var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"InterButton",class:[
        { 'block': _vm.block },
          _vm.styleBtn,
        { 'disabled': !_vm.enabled },
        _vm.size
        ],attrs:{"disabled":!_vm.enabled},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.currentLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }